import { cn } from "@/lib/utils";

interface ProgramsSectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  className?: string;
  variant?: "default" | "programs-page";
}

export function ProgramsSectionHeader({
  eyebrow = "Our Programs",
  title,
  subtitle,
  className,
  variant = "default",
}: ProgramsSectionHeaderProps) {
  const isProgramsPage = variant === "programs-page";

  return (
    <div className={cn("mb-10 text-center md:mb-12", className)}>
      <p
        className={cn(
          "mb-2 text-xs font-semibold uppercase tracking-[0.2em]",
          isProgramsPage ? "text-[var(--programs-green)]" : "text-primary"
        )}
      >
        {eyebrow}
      </p>
      {isProgramsPage ? (
        <h2 className="font-display mb-3 text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
          {title}
        </h2>
      ) : (
        <h2 className="font-display mb-3 text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="mx-auto max-w-2xl text-base text-muted md:text-lg">
          {subtitle}
        </p>
      )}
    </div>
  );
}
